import {reactive} from "vue";

const iconsDoc = fetch('https://public.nfhotel.pl/uploads/nf-icons.svg')
    .then(response => response.text()
        .then(text => {
            const parser = new DOMParser();
            return parser.parseFromString(text, 'image/svg+xml');
        })
    );
export const NfIconStore = reactive({
    // Mapa ikon, które zostały już załadowane lub są w trakcie ładowania.
    iconMap: {} as { [icon: string]: Promise<string> | string },
    async get(name: string): Promise<string> {
        if (!NfIconStore.iconMap[name]) {
            // Ustawiamy obiekt ikony na Promise<string>, aby uniknąć wielokrotnego ładowania tej samej ikony.
            NfIconStore.iconMap[name] = iconsDoc.then(doc => {
                const icon = doc.getElementById(name);
                if (!icon)
                    throw new Error(`Nieznana ikona '${name}'.`);
                // Po znalezieniu ikony zapamiętujemy jej zawartość i zwracamy ją.
                return NfIconStore.iconMap[name] = icon.innerHTML;
            });
        }
        // Zwracamy ikonę, jeśli jest już załadowana, lub Promise<string> jeśli nie.
        return NfIconStore.iconMap[name];
    }
});